import { type BaseTakingsRepository } from "../../_Bases/BaseTakingsRepository";
import { type LocalDatabaseTakings } from "../../_Bases/BaseTakingsRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBTakingRepository extends BaseIndexedDBRepository<
    LocalDatabaseTakings
> implements BaseTakingsRepository {
    public readonly source: InternalIndexedDBDatabase["takings"];
    protected readonly dataTypeName = "Taking";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.takings;
    }

    public getByType(type: string): Promise<Array<LocalDatabaseTakings>> {
        return this.source
            .where("type")
            .equals(type)
            .toArray();
    }
}
